import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  return (
    <div>
      <h1 className="page-title">BoilerWorks TypeForms Demo</h1>
      
      <div className="page-description">
        <p>Welcome to the BoilerWorks TypeForms demonstration. This application showcases the features and capabilities of our customizable form system, designed to create beautiful, interactive forms with minimal effort.</p>
        <p>Browse the examples below to see different form types and customization options.</p>
      </div>
      
      <div className="home-features">
        <div className="feature-section">
          <h2>Form Examples</h2>
          <ul>
            <li>
              <Link to="/contact-form">Contact Form</Link> - A standard contact form with validation
            </li>
            <li>
              <Link to="/survey-form">Survey Form</Link> - A customer satisfaction survey with multiple field types
            </li>
            <li>
              <Link to="/registration-form">Registration Form</Link> - A comprehensive user registration form
            </li>
          </ul>
        </div>
        
        <div className="feature-section">
          <h2>Customization Options</h2>
          <ul>
            <li>
              <Link to="/customization">Theme Customization</Link> - See how themes affect form appearance
            </li>
            <li>
              <Link to="/api-integration">API Integration</Link> - Learn how to integrate with the backend API
            </li>
          </ul>
        </div>
        
        <div className="feature-section">
          <h2>Key Features</h2>
          <ul>
            <li>Multi-step form navigation</li>
            <li>Progress tracking</li>
            <li>Custom cursor effects</li>
            <li>Theming support</li>
            <li>Validation</li>
            <li>Multiple field types</li>
            <li>Responsive design</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 